"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_dom_1 = __importDefault(require("react-dom"));
const App_1 = require("./App");
const office_ui_fabric_react_1 = require("office-ui-fabric-react");
const Styling_1 = require("office-ui-fabric-react/lib/Styling");
const icons_1 = require("@uifabric/icons");
icons_1.initializeIcons();
Styling_1.loadTheme({
    palette: {
        themePrimary: '#be0007',
        themeLighterAlt: '#fcf2f3',
        themeLighter: '#f5cecf',
        themeLight: '#eca5a7',
        themeTertiary: '#d9575b',
        themeSecondary: '#c7181e',
        themeDarkAlt: '#ac0006',
        themeDark: '#910005',
        themeDarker: '#6b0004',
        neutralLighterAlt: '#faf9f8',
        neutralLighter: '#f3f2f1',
        neutralLight: '#edebe9',
        neutralQuaternaryAlt: '#e1dfdd',
        neutralQuaternary: '#d0d0d0',
        neutralTertiaryAlt: '#c8c6c4',
        neutralTertiary: '#a19f9d',
        neutralSecondary: '#605e5c',
        neutralPrimaryAlt: '#3b3a39',
        neutralPrimary: '#323130',
        neutralDark: '#201f1e',
        black: '#000000',
        white: '#ffffff',
    }
});
// Inject some global styles
office_ui_fabric_react_1.mergeStyles({
    selectors: {
        ':global(body), :global(html), :global(#app)': {
            margin: 0,
            padding: 0,
            minHeight: '100vh'
        },
        ':global(#app)': {
            display: 'flex'
        }
    }
});
// Don't render if we are in an iframe
// Fixes login loop caused by msal.js creating iframes
// which redirect back to the app
if (window.self === window.top) {
    react_dom_1.default.render(react_1.default.createElement(App_1.App, null), document.getElementById('app'));
}
else {
    console.log('Not rendering app due to being inside iFrame');
}
